import { OrderFile } from './../../models/index';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-files',
  templateUrl: './order-files.component.html',
  styleUrls: ['./order-files.component.scss']
})
export class OrderFilesComponent implements OnInit {

  @Input()
  files: OrderFile[];

  constructor() { }

  ngOnInit(): void {
  }

}
